import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

/**
 * SEARCHES TITLE, EXCERPT AND EDITOR. NOT PAGEBLOCKS (POST META)
 *
 * NOTE: Submit input is optional.
 */

const SearchFilter = props => {
  function handleSearch(e) {
    props.onSearch(e.target.value)
  }

  function handleSubmit(e) {
    e.preventDefault()
    props.onSubmit()
  }

  return (
    <div className="c-search-filter">
      <form onSubmit={handleSubmit}>
        <input
          type="search"
          placeholder={props.placeholder}
          value={props.searchText}
          onChange={handleSearch}
          disabled={props.postsLoading ? true : false}
        />
      </form>
    </div>
  )
}

export default SearchFilter



// WEBPACK FOOTER //
// ./src/js/housing/components/SearchFilter.js